<template>
  <div class="item-box">
    <div class="box-header bb-1">
      <h1 class="fs-12 fc-3">Puan Hareketlerim</h1>
    </div>
    <div class="box-body px-0" style="padding-bottom: 0">
      <div
        class="puan-line bb-1 p-3"
        v-for="(item, index) in limit ? items.slice(0, 5) : items"
        :key="index"
      >
        <div class="row">
          <div class="col-10">
            <h1 class="fs-12 fc-2">
              {{item.title}}
              <span
                class="fs-10 fc-3 d-block font-weight-normal"
              >{{$dateTime(item.date.date)}}</span>
            </h1>
          </div>
          <div class="col-2">
            <h1 class="fs-24 fc-1">{{item.point}}</h1>
          </div>
          <div class="row" v-if="item.code != null && item.code != ''" style="margin: 0">
            <div
              class="col-12 fs-10 fc-3 d-block font-weight-normal"
              style="font-size: 12px"
            >Kampanya Kodu: {{item.code}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters" @click="limit = !limit" v-if="items.length>5">
      <div class="col-12">
        <div class="block-link text-center pb-3">
          <h1 class="fc-1 fs-14">
            <img
              src="/static/img/arrow-down.svg"
              :style="limit == false ? 'transform: rotate(180deg);' : ''"
              class="mr-2"
            />
            {{limit ? 'Daha Fazla Göster' : 'Daha Az Göster'}}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PointActions",
  data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("token", this.$store.state.user.token);

      axios.post("uyelik/profil-gecmisi", data).then(res => {
        this.$store.state.loading = false;
        this.items = res.data.data;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/PointActions.vue